import { render, staticRenderFns } from "./BcCharts.vue?vue&type=template&id=7829dcc4&scoped=true"
import script from "./BcCharts.vue?vue&type=script&lang=js"
export * from "./BcCharts.vue?vue&type=script&lang=js"
import style0 from "./BcCharts.vue?vue&type=style&index=0&id=7829dcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7829dcc4",
  null
  
)

export default component.exports